export interface Toast {
  id:      number;
  title:   string;
  message: string;
  kind:    'error' | 'success';
}

/** Evento que ToastContainer escucha en window. */
export const TOAST_EVENT = 'cp:toast';

// Public API — call from anywhere without prop-drilling
export function dispatchToast(toast: Omit<Toast, 'id'>) {
  window.dispatchEvent(new CustomEvent(TOAST_EVENT, { detail: toast }));
}
